package anjuros.development.sections


import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import anjuros.development.components.language.LocalText
import anjuros.development.components.language.ResKey
import anjuros.development.modules.Section
import anjuros.development.modules.Theme
import anjuros.development.util.Constants
import anjuros.development.util.Constants.CLIENTS_ADDRESS
import anjuros.development.util.Constants.DEV_WEB
import anjuros.development.util.Constants.FONT_FAMILY
import anjuros.development.util.Constants.SECTION_WIDTH
import anjuros.development.util.ContactButtonStyle
import anjuros.development.util.FooterMarginStyle
import anjuros.development.util.NavigationFooterItemStyle
import anjuros.development.util.rememberOrientation

import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import kotlin.js.Date

@Composable
fun  FooterSection(){


    Box(modifier = Modifier
        .fillMaxWidth()
        .maxWidth(SECTION_WIDTH.px)
        .margin(top = 40.px)
        .padding(topBottom = 10.px)
        .backgroundColor(Theme.DarkGrey.rgb),
        contentAlignment = Alignment.Center) {


       FooterContent()
    }
}

@Composable
private fun FooterContent(){
    val isLandscape  by  rememberOrientation()

    SimpleGrid(numColumns = numColumns(base=if(isLandscape) 3 else 1,md=3),
        modifier = Modifier.fillMaxSize()){
        FooterMenu()
        FooterLogo(
            isLandscape = isLandscape
        )
        FooterContact( isLandscape = isLandscape)
    }
}

@Composable
fun  FooterMenu(){
    Box(modifier = Modifier.fillMaxHeight()) {
        Column(
            modifier = Modifier.align(Alignment.Center),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {

            Section.entries.toTypedArray().forEach { section ->
                Link(
                    modifier = Modifier
                        .padding(
                            right = 0.px,
                            bottom = if(section.ordinal<Section.entries.size-1) 20.px else 0.px
                        )
                        .textDecorationLine(TextDecorationLine.None),
                    path = section.path
                ) {
                    P(
                        attrs = NavigationFooterItemStyle.toModifier()

                            .margin(topBottom = 0.px)
                            .fontFamily(FONT_FAMILY)
                            .fontSize(14.px)
                            .fontWeight(FontWeight.Normal)
                            .toAttrs()
                    ) {
                        Text(LocalText(section.subtitle))
                    }
                }

            }
        }
    }

}

@Composable
fun FooterLogo(
    isLandscape:Boolean
){

    Box(
        modifier = FooterMarginStyle.toModifier().fillMaxWidth()
    ) {
        Box(
            modifier = Modifier.fillMaxHeight().displayIfAtLeast(Breakpoint.MD).width(3.px).backgroundColor(Colors.White)
                .align(Alignment.CenterStart)
        )
        Box(
            modifier = Modifier.fillMaxHeight().displayIfAtLeast(Breakpoint.MD).width(3.px).backgroundColor(Colors.White)
                .align(Alignment.CenterEnd)
        )

        Box(
            modifier = Modifier
                .align(Alignment.Center)
                .margin(bottom = 20.px)
        ) {
            Row(
                horizontalArrangement = Arrangement.spacedBy(20.px),
                verticalAlignment = Alignment.CenterVertically
            ) {
                CompanyDetails(
                    modifier = Modifier
                )
            }
        }

        if(isLandscape) {
            Box(modifier = Modifier.align(Alignment.BottomCenter)) {
                AnjurosCopyright(Modifier.align(Alignment.BottomCenter))
            }
        }
    }

}

@Composable
fun AnjurosCopyright(modifier: Modifier){
    val date = remember { Date().getFullYear() }
    Link(
        modifier = modifier
            .margin(top=10.px)
            .fontFamily(FONT_FAMILY)
            .fontSize(12.px)
            .fontWeight(FontWeight.Bold)
            .textDecorationLine(TextDecorationLine.None)
            .color(Colors.White),
        path = DEV_WEB,
        openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
    ) {
        Text("Copyright © $date Anjuros Development, All rights Reserved.")
    }
}

@Composable
fun FooterContact( isLandscape:Boolean){

    Box(modifier = Modifier.fillMaxHeight()) {
        Column(
            modifier = Modifier.align(Alignment.Center),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Link(
                modifier = Modifier
                    .margin(bottom = 10.px)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(20.px)
                    .fontWeight(FontWeight.Normal)
                    .color(Colors.White)
                    .textDecorationLine(TextDecorationLine.None),
                path = "tel:${Constants.CLIENTS_PHONE}"
            ) {
                Text(Constants.CLIENTS_PHONE)
            }
            Link(
                modifier = Modifier
                    .margin(top = 10.px)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(20.px)
                    .fontWeight(FontWeight.Normal)
                    .color(Colors.White)
                    .textDecorationLine(TextDecorationLine.None),
                path = "tel:${Constants.CLIENTS_PHONE2}"
            ) {
                Text(Constants.CLIENTS_PHONE2)
            }

            Box(
                modifier = ContactButtonStyle.toModifier()
                    .margin(top = 30.px)
                    .backgroundColor(Colors.White)
                    .borderRadius(5.px)
            ) {
                Link(
                    path = Constants.CLIENTS_BOOKING,
                    modifier = Modifier
                        .textDecorationLine(TextDecorationLine.None)
                        .align(Alignment.Center)

                ) {
                    P(
                        attrs = Modifier
                            .margin(5.px)
                            .align(Alignment.Center)
                            .fontFamily(Constants.FONT_FAMILY)
                            .color(Theme.Primary.rgb)
                            .fontSize(20.px)
                            .fontWeight(FontWeight.Bold)
                            .toAttrs()
                    ) {
                        Text(LocalText(ResKey.BOOKING))
                    }
                }
            }
            if(!isLandscape) {
                Box(modifier = Modifier.displayUntil(Breakpoint.MD).margin(top = 5.px)) {
                    AnjurosCopyright(Modifier.align(Alignment.BottomCenter))
                }
            }

        }

    }
}

@Composable
fun CompanyDetails(modifier: Modifier){

    Column(modifier = modifier
    ){
        P(
            attrs = Modifier

                .margin(topBottom = 0.px)
                .fontFamily(FONT_FAMILY)
                .fontSize(24.px)
                .textAlign(TextAlign.Center)
                .color(Colors.White)
                .fontWeight(FontWeight.Normal)
                .toAttrs()
        ) {
            Text(Constants.CLIENTS_COMPANY)
        }
        P(
            attrs = Modifier

                .margin(topBottom = 0.px)
                .fontFamily(FONT_FAMILY)
                .fontSize(18.px)
                .color(Colors.White)
                .fontWeight(FontWeight.Normal)
                .toAttrs()
        ) {
            Text(CLIENTS_ADDRESS)
        }
    }
}